import {DossierN3, DossierT100, DossierT250} from "./base.model";
import {SvedClientType} from "./svedClientType.model";

export class SvedVPRType extends SvedClientType {
  part: DossierN3 = '';
  dateFrom = false;
  vprProfit: DossierN3 = '';
  vprOther: DossierT100 = '';
  reason: DossierT250 = '';
}
